import React, { FC } from 'react'

import { css } from '@emotion/core'
import { useTheme } from 'emotion-theming'

import SVGIcon from 'components/common/atoms/SVGIcon'
import StepBox from 'components/common/molecules/StepBox'

type TimelineProps = {
  steps: {
    icon: string
    title: string
    description: string
  }[]
}

const timelineStyle = (theme: ThemeType) => css`
  .timeline {
    &__wrapper {
      display: flex;
      flex-direction: column;
    }
    &__icon {
      border-radius: 100%;
      background-color: ${theme.campus.aqua30};
      padding: 12px;
      margin-right: 24px;
      z-index: 1;
    }
    &__step {
      position: relative;
      display: flex;
      align-items: start;
      &:not(:first-of-type) {
        .timeline__box,
        .timeline__icon {
          margin-top: 16px;
        }
      }
      &::after {
        content: '';
        position: absolute;
        background-color: ${theme.campus.aqua30};
        top: 0;
        width: 3px;
        bottom: 0;
        left: 23px;
        z-index: 0;
      }
      &:last-child::after {
        height: 16px;
      }
    }
    &__box {
      height: 201px;
      .step-box {
        height: 100%;
      }
    }
    @media screen and (min-width: 768px) {
      &__wrapper {
        flex-direction: row;
      }
      &__icon {
        margin: 0 0 40px 0;
      }
      &__step {
        flex: 1 1 50%;
        flex-direction: column;
        align-items: center;
        &:not(:first-of-type) {
          .timeline__box {
            margin: 0 0 0 16px;
          }
          .timeline__icon {
            margin-right: 0;
            margin-top: 0;
          }
        }
        &::after {
          width: 100%;
          height: 4px;
          top: 23px;
          bottom: 0;
        }
        &:first-of-type::after {
          left: 50%;
        }
        &:last-child::after {
          width: 50%;
          height: 4px;
        }
      }
      &__box {
        flex-grow: 2;
        height: auto;
      }
    }
  }
`

const Timeline: FC<TimelineProps> = ({ steps }) => {
  const theme: ThemeType = useTheme()
  return (
    <div className="timeline" css={timelineStyle(theme)}>
      <div className="timeline__wrapper">
        {steps.map((step, idx) => (
          <div className="timeline__step" key={`step-${idx}`}>
            <div className="timeline__icon">
              <SVGIcon name={step.icon} size="md" />
            </div>
            <div className="timeline__box">
              <StepBox idx={idx + 1} title={step.title} description={step.description} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Timeline
